<template>

    <booking :data="booking" />

</template>

<script>

    import axios from '../utils/Http.js'
    import booking from '../components/booking/Booking.vue'
    
    export default {

        components: {
            booking
        },
        data: function() {
            return {
                booking: null
            }
        },
        watch: {
            '$route' (to, from) {   
                this.fetchBooking(this.$route.params.id)
            }
        },
        methods: {
            fetchBooking: function(id) {
                axios({
                    method: 'get',
                    url: `/booking/booking/${ id }/`,
                    headers: {
                        'Authorization': 'Token ' + this.$store.state.auth.sessionKey
                    }
                })
                .then(res => {
                    this.booking = res.data
                })
                .catch(err => console.log(err))
            }
        },
        created: function() {
            this.fetchBooking(this.$route.params.id)
        }
           
    }

</script>
